import React from "react";
import { SimpleTableHeader } from "../SimpleTableHeader";
import { useSimpleTableContext } from "../../../contexts/SimpleTableContext";
import { useFilterContext } from "@/contexts/FilterContext";
import type { BaseEntity } from "../../../types";

/**
 * Renders header controls section of SimpleTableDesktopView
 * Includes sorting, filtering, and bulk action controls
 * Consumes data directly from SimpleTableContext and FilterContext
 */
export function SimpleTableHeaderSection<TData extends BaseEntity>() {
  const context = useSimpleTableContext<TData>();
  const filterContext = useFilterContext<TData>();

  const {
    config,
    state,
    callbacks,
    paginatedData,
    groupingContext,
    groupableFields,
  } = context;

  const {
    filters,
    uiState,
    actions,
  } = filterContext;

  return (
    <SimpleTableHeader
      config={config}
      selectedItems={state.selectedItems}
      sortColumns={state.sortColumns.map((col, index) => ({
        ...col,
        priority: col.priority ?? index + 1,
      }))}
      removeSortColumn={callbacks.removeSortColumn}
      clearAllSorting={callbacks.clearAllSorting}
      handleBulkAction={callbacks.handleBulkAction}
      resetColumnWidthsCallback={callbacks.resetColumnWidthsCallback}
      paginatedData={paginatedData}
      advancedFilterProps={{
        advancedFilters: filters.advanced,
        filterOperator: uiState.filterOperator,
        setFilterOperator: actions.setFilterOperator,
        addAdvancedFilter: callbacks.addAdvancedFilter,
        removeAdvancedFilter: callbacks.removeAdvancedFilter,
        clearAllAdvancedFilters: callbacks.clearAllAdvancedFilters,
      }}
      groupingContext={groupingContext}
      groupableFields={groupableFields}
    />
  );
}
